import './libs/pin';
import copyLink from './modules/_copy';
import resizableIframe from './modules/_resizableIframe';
import previewSlider from './sliders/previewSlider/previewSlider';

$(document).ready(() => {
  copyLink();
  resizableIframe();

  $("#aside").pin({
    containerSelector: ".article-wrapper",
    padding: {
      top: 40,
      bottom: 10,
    }
  });

  const previewSliders = Array.prototype.slice.call(document.querySelectorAll('.js-preview-slider-wrapper'));
  if (previewSliders.length) {
    previewSliders.forEach((el) => {
      previewSlider(el);
    });
  }
});
